import React, { Fragment, Component } from 'react'
import { connect } from 'react-redux'
import ClockDissolve from '../components/ClockDissolve'
import { withStyles } from '@material-ui/core/styles'
import { makeGetPaint } from '../selectors/paintSelector'
import format from 'date-fns/format'

const id = 'Sentinel2PipelineChangeDetection'
const datetimeId = 'PipelineChangeDetection'
const datetimeIdBase = 'PipelineChangeDetectionBase'

const styles = {
  container: {
    position: 'absolute',
    bottom: '50px',
    right: '150px'
  }
}

class ClockDissolveContainer extends Component {
  render () {
    const { classes, paint, time, timeBase, showDissolveClock } = this.props
    if (!showDissolveClock) {
      return null
    }

    const ratio = this.props.paint['raster-opacity']

    const dateTop = format(new Date(time), "dd LLLL yyyy")
    return (
      <div className={classes.container} >
        <ClockDissolve ratio={ratio} dateTop={dateTop} />
      </div>
    )
  }
}

const mapStateToProps = state => {
  const getPaint = makeGetPaint()
  const paintId = 'Sentinel2PipelineChangeDetection'
  return {
    ratio: {},
    paint: getPaint(state, paintId),
    time: state.layer.times[datetimeId] || undefined,
    timeBase: state.layer.times[datetimeIdBase] || undefined,
    showDissolveClock: state.service.serviceCardActive.showDissolveClock
  }
}

export default connect(mapStateToProps, null)(withStyles(styles)(ClockDissolveContainer))



// WEBPACK FOOTER //
// ./src/containers/ClockDissolveContainer.js